import React from 'react';
import { connect } from 'react-redux';
import { updateAdhocInfo, searchAdhoc, updateStudyList,
  updateMilestoneList, updateRelatedTaskList } from './thunks';
import Container from 'react-bootstrap/Container';
// import Row from 'react-bootstrap/Row';
// import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Select, { components } from 'react-select';
import DatePicker from "react-datepicker";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { getMomentDate } from './util';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import './NavAdhocSub.css';

const NavAdhocSub = ({ appInfo, adhocInfo, startSearchAdhoc, startUpdateRelatedTaskList,
  startUpdateAdhocInfo, startUpdateStudyList, startUpdateMilestoneList }) => {

  const onAdhocReportSearch = (event) => {
    // search for adhoc report
    let searchData = {
      program: adhocInfo.searchParameter.program,
      study: adhocInfo.searchParameter.study,
      milestone: adhocInfo.searchParameter.milestone,
      related_task_name: adhocInfo.searchParameter.related_task_name,
      request_start_date: adhocInfo.searchParameter.request_start_date,
      request_end_date: adhocInfo.searchParameter.request_end_date,
      requester_name: adhocInfo.searchParameter.requester_name,
      requester_org: adhocInfo.searchParameter.requester_org,
      description: adhocInfo.searchParameter.description,
    };
    console.log('>>> searchData:', searchData);
    startSearchAdhoc(searchData);
    event.preventDefault();
    return false;
  };

  const onAdhocReportReset = (event) => {
    // reset adhoc search subbar
    console.log('>>> onAdhocReportReset');
    let searchParameter = getSearchParameter();
    for (var property in searchParameter) {
      searchParameter[property] = '';
    }
    startUpdateAdhocInfo({ searchParameter:searchParameter });
    event.preventDefault();
    return false;
  };

  const getSearchParameter = (data) => {
    let result = {
      program: adhocInfo.searchParameter.program,
      study: adhocInfo.searchParameter.study,
      milestone: adhocInfo.searchParameter.milestone,
      related_task_name: adhocInfo.searchParameter.related_task_name,
      request_start_date: adhocInfo.searchParameter.request_start_date,
      request_end_date: adhocInfo.searchParameter.request_end_date,
      requester_name: adhocInfo.searchParameter.requester_name,
      requester_org: adhocInfo.searchParameter.requester_org,
      description: adhocInfo.searchParameter.description,
    };
    for (var property in data) {
      result[property] = data[property];
    }
    return result;
  };

  const onProgramChange = (data) => {
    // console.log('>>> onProgramChange');
    console.log('>>> onProgramChange program:', data.value);
    startUpdateStudyList({ program:data.value });
    startUpdateRelatedTaskList({ program:data.value });
    startUpdateAdhocInfo({ searchParameter: getSearchParameter({
      program: data.value,
      study: '',
      milestone: '',
      related_task_name: ''
    })});
  };

  const onStudyChange = (data) => {
    console.log('>>> onStudyChange', data);
    startUpdateRelatedTaskList({
      program: adhocInfo.searchParameter.program,
      study: data.value
    });
    startUpdateMilestoneList({
      program: adhocInfo.searchParameter.program,
      study: data.value
    });
    startUpdateAdhocInfo({ searchParameter: getSearchParameter({
      study: data.value,
      milestone: '',
      related_task_name: ''
    })});
  };

  const onMilestoneChange = (data) => {
    console.log('>>> onMilestoneChange', data);
    startUpdateRelatedTaskList({
      program: adhocInfo.searchParameter.program,
      study: adhocInfo.searchParameter.study,
      milestone: data.value,
    });
    startUpdateAdhocInfo({ searchParameter: getSearchParameter({
      milestone: data.value,
      related_task_name: ''
    })});
  };

  const onRelatedTaskChange = (data) => {
    console.log('>>> onRelatedTaskChange', data);
    startUpdateAdhocInfo({ searchParameter: getSearchParameter({
      related_task_name: data.value
    })});
  };

  const onDateChange = (data) => {
    console.log('>>> onDateChange:', data);
    let input = {};
    input[data.field] = data.value;
    startUpdateAdhocInfo({ searchParameter: getSearchParameter(input)});
  };

  const onRequesterChange = (data) => {
    console.log('>>> onRequesterChange user:', data.value);
    startUpdateAdhocInfo({ searchParameter: getSearchParameter({
      requester_name: data.value,
    })});
  };

  const onRequesterOrgChange = (value) => {
    console.log('>>> onRequesterOrgChange:', value);
    let input = { requester_org:value };
    startUpdateAdhocInfo({ searchParameter: getSearchParameter(input)});
  };

  const onDescriptionChange = (event) => {
    console.log('>>> onDescriptionChange:', event.target.value);
    let input = { description:event.target.value };
    startUpdateAdhocInfo({ searchParameter: getSearchParameter(input)});
  };

  const Placeholder = props => {
    return <components.Placeholder {...props} />;
  };

  return (
    <div className="NavAdhocSub">
      <Container fluid>
        <form className="form-nav-adhoc">
          <div className="form-row align-items-center">
            <div className="col-2">
              <Form.Group>
                <Select
                  components={ Placeholder }
                  placeholder={'Program'}
                  styles={{
                    placeholder: base => ({
                      ...base,
                      fontSize: '1em',
                      color: '#919191',
                      fontWeight: 400,
                    }),
                  }}
                  value={ adhocInfo.searchParameter.program ? {
                    label: adhocInfo.searchParameter.program,
                    value: adhocInfo.searchParameter.program
                  }: null }
                  options={ (appInfo.programs || []).map((item, index) => (
                    { label:item.program, value:item.program }
                  )) }
                  onChange={ onProgramChange } />
              </Form.Group>
            </div>
            <div className="col-2">
              <Form.Group>
                <Select
                  components={ Placeholder }
                  placeholder={'Study'}
                  styles={{
                    placeholder: base => ({
                      ...base,
                      fontSize: '1em',
                      color: '#919191',
                      fontWeight: 400,
                    }),
                  }}
                  value={ adhocInfo.searchParameter.study ? {
                    label: adhocInfo.searchParameter.study,
                    value: adhocInfo.searchParameter.study
                  }: null }
                  options={ (appInfo.studies || []).map((item, index) => (
                    { label:item.study_name, value:item.study_name }
                  )) }
                  onChange={ onStudyChange } />
              </Form.Group>
            </div>
            <div className="col-2">
              <Form.Group>
                <Select
                  components={ Placeholder }
                  placeholder={'Milestone'}
                  styles={{
                    menu: styles => ({ ...styles,
                      width: '300px'
                    }),
                    placeholder: base => ({
                      ...base,
                      fontSize: '1em',
                      color: '#919191',
                      fontWeight: 400,
                    }),
                  }}
                  value={ adhocInfo.searchParameter.milestone ? {
                    label: adhocInfo.searchParameter.milestone,
                    value: adhocInfo.searchParameter.milestone
                  }: null }
                  options={ (appInfo.milestones || []).map((item, index) => (
                    { label:item.milestone_name, value:item.milestone_name }
                  )) }
                  onChange={ onMilestoneChange } />
              </Form.Group>
            </div>

            <div className="col-2">
              <Form.Group>
                <Select
                  components={ Placeholder }
                  placeholder={'Task'}
                  styles={{
                    menu: styles => ({ ...styles,
                      width: '300px'
                    }),
                    placeholder: base => ({
                      ...base,
                      fontSize: '1em',
                      color: '#919191',
                      fontWeight: 400,
                    }),
                  }}
                  value={ adhocInfo.searchParameter.related_task_name ? {
                    label: adhocInfo.searchParameter.related_task_name,
                    value: adhocInfo.searchParameter.related_task_name
                  }: null }
                  options={ (appInfo.relatedTasks || []).map((item, index) => (
                    { label:item.name, value:item.name }
                  )) }
                  onChange={ onRelatedTaskChange } />
              </Form.Group>
            </div>

            <div className="col-auto">
              <Form.Group className="form-date-group">
                <div>
                  <DatePicker
                    className="form-control"
                    value={adhocInfo.searchParameter.request_start_date}
                    selected={getMomentDate(adhocInfo.searchParameter.request_start_date)}
                    placeholderText="Request Start Date"
                    onChange={date => onDateChange({ field:'request_start_date', value:date })} />
                </div>
              </Form.Group>
            </div>
            <div className="col-auto">
              <Form.Group className="form-date-group">
                <div>
                  <DatePicker
                    className="form-control"
                    value={adhocInfo.searchParameter.request_end_date}
                    selected={getMomentDate(adhocInfo.searchParameter.request_end_date)}
                    placeholderText="Request End Date"
                    onChange={date => onDateChange({ field:'request_end_date', value:date })} />
                </div>
              </Form.Group>
            </div>
            <div className="col-2">
              <Form.Group>
                <Select
                  components={ Placeholder }
                  placeholder={'Requester'}
                  styles={{
                    menu: styles => ({ ...styles,
                      width: '180px'
                    }),
                    placeholder: base => ({
                      ...base,
                      fontSize: '1em',
                      color: '#919191',
                      fontWeight: 400,
                    }),
                  }}
                  value={ adhocInfo.searchParameter.requester_name ? {
                    label: adhocInfo.searchParameter.requester_name,
                    value: adhocInfo.searchParameter.requester_name
                  }: null }
                  options={ (adhocInfo.requesters || []).map((item, index) => (
                    { label:item.requester_name, value:item.requester_name }
                  )) }
                  onChange={ onRequesterChange } />
              </Form.Group>
            </div>
            <div className="col-2">
              <Form.Group>
                <Select
                  components={ Placeholder }
                  placeholder={'Req Org'}
                  styles={{
                    menu: styles => ({ ...styles,
                      width: '240px'
                    }),
                    placeholder: base => ({
                      ...base,
                      fontSize: '1em',
                      color: '#919191',
                      fontWeight: 400,
                    }),
                  }}
                  value={ adhocInfo.searchParameter.requester_org ? {
                    label: adhocInfo.searchParameter.requester_org,
                    value: adhocInfo.searchParameter.requester_org
                  }: null }
                  options={ (adhocInfo.AdhocRequesterOrg || []).map((item, index) => (
                    { label:item.code_value, value:item.code_value }
                  )) } onChange={ opt => onRequesterOrgChange(opt.value) } />
              </Form.Group>
            </div>
            <div className="col-2">
              <div className="input-group">
                <input type="text" className="form-control"
                  value={adhocInfo.searchParameter.description}
                  placeholder="Description"
                  onChange={ onDescriptionChange } />
              </div>
            </div>
            <div className="col-auto">
              <div>
                <button type="submit" className="btn btn-adhoc btn-adhoc-report-search"
                  onClick={onAdhocReportSearch}>Search</button>
                <button type="submit" className="btn btn-adhoc btn-adhoc-reset-search"
                  onClick={onAdhocReportReset}>Reset</button>
              </div>
            </div>
          </div>
        </form>
      </Container>
    </div>
  );
}

const mapState = state => ({
  appInfo: state.appInfo,
  adhocInfo: state.adhocInfo,
});

const mapDispatch = dispatch => ({
  startUpdateStudyList: (data) => dispatch(updateStudyList(data)),
  startUpdateMilestoneList: (data) => dispatch(updateMilestoneList(data)),
  startUpdateRelatedTaskList: (data) => dispatch(updateRelatedTaskList(data)),
  startUpdateAdhocInfo: (data) => dispatch(updateAdhocInfo(data)),
  startSearchAdhoc: (data) => dispatch(searchAdhoc(data)),
});

export default connect(mapState, mapDispatch)(NavAdhocSub);
